<body>
    <div class="content flex-row">
        <div #div2 class="div2 flex-100 flex-column">
            <div class="container">
                <div *ngIf="oneAction" class="map-label-container center-center">
                    <div class="action-container">
                        <label class="filter-analysis">{{ action }}</label>
                    </div>
                </div>
                 <google-map id="map" #map [center]="center" [zoom]="zoom" [options]="options"
                  width="100%" height="100%">
                    <map-ground-overlay *ngFor="let object of images" [url]="object.image" [bounds]="object.bounds"
                        [opacity]="opacity">
                    </map-ground-overlay>

                <map-marker #markerId="mapMarker" class="marker" *ngFor="let marker of markers"
                    [position]="marker.position" [label]="marker.label" [title]="marker.title"
                    [options]="marker.options">
                </map-marker>

                </google-map>
                                     <div  class="toggle-main-container">
                                         <div class="flex-row gap-5">
                                             <button mat-icon-button class="map-toggle-container" *ngIf="isAnalysisEmpty">
                                                 <div class="button-content">
                                                     <div class="history-icon-container">
                                                         <mat-icon class="expand-rankings">expand_less</mat-icon>
                                                     </div>
                                                     <div class="history-label-container">
                                                         <label class="expand-rankings-label">{{ 'MAPPING.MAPS-DATA' | translate }}</label>
                                                     </div>


                                                 </div>

                                             </button>

                                         </div>

                                     </div>

                                     <div class="history-filter-container" *ngIf="!hideAnalysisLabel">
                                        <div class="filter-container" >
                        
                                            <label class="filter-analysis">{{ selectedSatImage }}</label>
                                            <label class="filter-dates">
                                                {{selectedDate}}
                                            </label>
                                        </div>
                        
                                    </div>

                <div class="scrollableLegend-container-farm" *ngIf="farmLegends.length != 0">
                    <div class="scrollableLegend-farm">
                        <div class="inner-legend-container-farm" *ngFor="let farmdLegend of farmLegends">
                            <div class="legend-color-farm" [style.background-color]="farmdLegend.colour"></div>
                            <label class="legend-value-farm">{{ farmdLegend.value }} {{ farmdLegend.area}}</label>
                        </div>
                    </div>
                </div>

                <eco-fab-speed-dial
                    class="speed-dial-container">
                    <eco-fab-speed-dial-trigger >
                        <button  mat-fab label="menu" class="map-menu-circular" (click)="openOptions()" >
                            <mat-icon  class="material-icons">add</mat-icon>
                        </button>
                    </eco-fab-speed-dial-trigger>

                    <eco-fab-speed-dial-actions [style]="isOpen ? '' : 'display: none;'">
                        <button mat-mini-fab color="white"  data-title="Hide/Show Farm Labels"
                            aria-label="showFieldLabels" (click)="toggleFarmNameLabels()">
                            <mat-icon class="material-icons">label_outline</mat-icon>
                        </button>

                 <button mat-mini-fab color="white"  data-title="Timeline Gridding View"
                            aria-label="showFieldLabels" (click)="showGriddingOptions()">
                            <mat-icon class="material-icons">grid_4x4</mat-icon>
                </button>
                    </eco-fab-speed-dial-actions>
                </eco-fab-speed-dial>
            </div>
        </div>

        <div *ngIf="saveFields" class="toggle-main-button end-center">
            <button class="update-fields" mat-flat-button type="button">{{ 'MAPPING.SAVE-CHANGES' | translate }}</button>
        </div>

        <div *ngIf="saveEditedField" class="toggle-main-button end-center">
            <button class="update-fields" mat-flat-button type="button">{{ 'MAPPING.ADD-FIELD' | translate }}</button>
        </div>

    </div>
</body>

